export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBwl1-vnxtupQNPH2CC_tLcNCiiDcK8q94',
    authDomain: 'contacto-velas-ar.firebaseapp.com',
    projectId: 'contacto-velas-ar',
    storageBucket: 'contacto-velas-ar.firebasestorage.app',
    messagingSenderId: '965917975789',
    appId: '1:965917975789:web:63bb4d663a2b85c3bd58e4'
  },
  recaptcha: {
    siteKey: '6LdAuP4rAAAAAOhO5txDnpCXAomoOXHOUL7eDfxI'
  }
};

